// src/firebase.js
// Firebase initialization and auth helpers
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Values are read from environment variables so developers can provide their
// own Firebase project configuration without committing secrets.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Determine if all config values are provided
const hasConfig = Object.values(firebaseConfig).every((val) => val !== undefined);

let app;
let auth;
let db;
const provider = new GoogleAuthProvider();

if (!hasConfig) {
  console.error('Firebase configuration not provided');
} else {
  // Initialize Firebase only when configuration is present
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
}

const firebaseInitialized = !!app;

export { auth, provider, db, firebaseInitialized };

